import { render, staticRenderFns } from "./SelectWarehouse.vue?vue&type=template&id=452738ad&scoped=true&"
import script from "./SelectWarehouse.vue?vue&type=script&lang=js&"
export * from "./SelectWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./SelectWarehouse.vue?vue&type=style&index=0&id=452738ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452738ad",
  null
  
)

export default component.exports